import { RecruitPreferenceOption } from "./recruitPreferenceOption.model";

export class RecruitPreferenceType {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.description = json && json.description || null;
        this.code = json && json.code || null;
        this.parentID = json && json.parent_preference_type_id || null;
        this.forPlayer = json && json.for_player || false;
        this.controlTypeID = json && json.control_type_id || null;
        this.controlTypeCode = json && json.control_type_code || null;
        this.options = [];
    }

    id: number;
    description: string;
    code: string;
    parentID: number | null;
    forPlayer: boolean;
    options: RecruitPreferenceOption[];
    controlTypeID: number;
    controlTypeCode: string;
}